import * as mt from './mutation-types';
import { MetadataState } from './types';

export default {
  [mt.TOGGLE_LABEL_MARKER] (state: MetadataState) {
    state.showLabelMarker = !state.showLabelMarker;
  }
};
